<div class="dialog-container">
  <div class="sheet-handle" aria-hidden="true"></div>
  <header class="dialog-header">
    <h1 class="dialog-title" mat-dialog-title>Leute hinzufügen</h1>
    <button (click)="close()"
      class="dialog-close-button"
      mat-icon-button
      aria-label="Dialog schließen"
    >
      <svg
        class="close-icon"
        width="18"
        height="18"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2 2L12 12M12 2L2 12" stroke="#1C1B1F" stroke-width="1.8" stroke-linecap="round" />
      </svg>
    </button>
  </header>

  <div class="dialog-content-wrapper">
    <mat-dialog-content class="dialog-content">
      <mat-radio-group
        [(ngModel)]="selectedOption"
        class="options-group"
        aria-label="Wählen Sie eine Option"
      >
        <mat-radio-button class="option-item mat-radio-button" value="all" checked="true">
          <span class="option-text">
            Alle Mitglieder von
            <a class="dialog-link" href="#" (click)="$event.preventDefault()">everyone</a>
            hinzufügen
          </span>
        </mat-radio-button>

        <mat-radio-button class="option-item mat-radio-button" value="specific">
          <span class="option-text">Bestimmte Leute hinzufügen</span>
        </mat-radio-button>
      </mat-radio-group>
    </mat-dialog-content>
    @if (selectedOption === 'specific') {
    <mat-form-field appearance="outline" class="form-field">
      <div class="input-wrapper">
        <input
          [(ngModel)]="inputValue"
          matInput
          [placeholder]="selectedUsers.length === 0 ? 'Name eingeben' : ''"
          class="user-input-field"
        />
        @for(user of selectedUsers; track user.uid) {
        <app-contact-chip
          [userData]="user"
          [usersSelected]="selectedUsers"
          [isRemovable]="user.uid !== currentUser?.uid"
        ></app-contact-chip>
        }
      </div>
    </mat-form-field>
    @if (inputValue.length > 0) {
    <app-mention-list
      [allSelectedUsers]="selectedUsers"
      (userSelected)="addUserToChosen($event)"
      [searchTerm]="inputValue"
      [visible]="showMention"
      [mode]="mentionMode"
      [users]="mentionUsers"
    ></app-mention-list>
    } }

    <mat-dialog-actions class="dialog-actions" align="end">
      <button
        [class.disabled]="selectedOption == 'specific' && selectedUsers.length == 0"
        class="dialog-action-button"
        (click)="onConfirm()"
      >
        Erstellen
      </button>
    </mat-dialog-actions>
  </div>
</div>
